import { Injectable } from '@angular/core';

import { AnalyticsBrowser } from '@segment/analytics-next';
import { of, ReplaySubject } from 'rxjs';
import { catchError, shareReplay, tap } from 'rxjs/operators';

import { AnalyticsAdapter, throwClientLoadingError } from '@core/analytics-types';
import type {
  AnalyticsAPIMethods,
  AnalyticsClientOptions,
  ClientIdentifyCallbackFn,
} from '@core/analytics-types';

@Injectable()
export class AnalyticsSegmentAdapter extends AnalyticsAdapter {
  public readonly ready$ = new ReplaySubject<void>(1);

  public load(key: string, options?: AnalyticsClientOptions) {
    const client = AnalyticsBrowser.load({ writeKey: key }, options);
    return of(this.segmentAdapter(client)).pipe(
      catchError(() => throwClientLoadingError()),
      tap((_client: any) => {
        _client.addDestinationMiddleware('Intercom', ({ payload, next }: any) => {
          const type = payload.obj.type;

          if (type === 'identify') {
            if (payload.obj.traits.tellent_user_guid) {
              const { tellent_user_guid } = payload.obj.traits;
              payload.obj.userId = tellent_user_guid;
            }

            payload.obj.email = payload.obj.traits.email;
          }

          next(payload);
        });
      }),
      shareReplay(1),
    );
  }

  private segmentAdapter(input: AnalyticsBrowser): AnalyticsAPIMethods {
    return {
      ...input,
      identify: (
        userId?: number,
        traits?: Record<string, string | number | boolean>,
        options?: AnalyticsClientOptions,
        callback?: ClientIdentifyCallbackFn,
      ) => {
        input.identify(`${userId}`, traits, options, () => {
          this.ready$.next();

          if (callback) {
            callback();
          }
        });
      },
    };
  }
}
